import LanguageSelector from "../../../../Common/Toggle";

const Language = () => {
  return <LanguageSelector />;
};

export default Language;
